import React from 'react';
import { ProgressIndicator } from './ProgressIndicator';
import { ArrowLeft } from 'lucide-react';
interface SlideLayoutProps {
  children: React.ReactNode;
  footer?: string;
  progress?: {
    current: number;
    total: number;
  };
  onBack?: () => void;
}
export function SlideLayout({
  children,
  footer,
  progress,
  onBack
}: SlideLayoutProps) {
  return <div className="relative w-full h-full bg-gradient-to-br from-blue-50 via-teal-50/30 to-emerald-50/20 overflow-hidden flex flex-col" data-id="element-16">
      {/* Top Banner */}
      <header className="w-full px-8 py-4 flex items-center justify-between flex-shrink-0" style={{
      background: 'linear-gradient(135deg, #0D2B45 0%, #1B3A5C 40%, #0E8585 100%)'
    }} data-id="element-17">
        <div className="flex-1" data-id="element-18">
          {onBack && <button onClick={onBack} className="flex items-center gap-2 text-white hover:text-highlight transition-colors duration-200 font-semibold" type="button" data-id="element-19">
              <ArrowLeft className="w-5 h-5" data-id="element-20" />
              Back
            </button>}
        </div>
        <div className="flex items-center gap-8" data-id="element-21">
          {progress && <div className="bg-white text-primary px-4 py-1.5 rounded-full text-sm font-semibold" data-id="element-22">
              {progress.current}/{progress.total}
            </div>}
          <img src="https://cdn.magicpatterns.com/uploads/kwT7adHpJchCEjPQy8hNic/vabysmo-logo.genecoreimg.750.png" alt="Vabysmo" className="h-10 w-auto" data-id="element-23" />
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 flex items-center justify-center px-12 py-6 overflow-hidden min-h-0" data-id="element-24">
        <div className="w-full h-full flex items-center justify-center" data-id="element-25">
          {children}
        </div>
      </main>

      {/* Bottom Banner */}
      <footer className="w-full px-8 py-4 flex items-center justify-between flex-shrink-0" style={{
      background: 'linear-gradient(135deg, #0D2B45 0%, #1B3A5C 40%, #0E8585 100%)'
    }} data-id="element-26">
        <div className="flex-1" data-id="element-27">
          {footer && <p className="text-xs text-white opacity-80" data-id="element-28">{footer}</p>}
        </div>
        <img src="https://cdn.magicpatterns.com/uploads/5jhXUGPCcHgVPg96gzBpYf/Roche_Logo_800px_White_RGB_Roche_Logo_RGB.png" alt="Roche" className="h-6 w-auto" data-id="element-29" />
      </footer>
    </div>;
}